import { ID } from 'domain/bubble';
import '@pixi/core';
import { AnimatedGIF } from '@pixi/gif';
import * as PIXI from 'pixi.js';

export type CachedSprites = (PIXI.Sprite | PIXI.AnimatedSprite)[];

const debounce = () =>
  new Promise((res) => {
    setTimeout(() => res(true), 4);
  });

export async function fetchImage(id: ID, source?: string) {
  if (!source) {
    return { [id]: null };
  }
  if (source.includes('.gif')) {
    const app = new PIXI.Application();
    const testFetch = await fetch(source);
    const testBuffer = await testFetch.arrayBuffer();
    const res = AnimatedGIF.fromBuffer(testBuffer);
    app.stage.addChild(res);

    await debounce();
    return { [id]: res };
  }
  const texture = PIXI.Sprite.from(source);
  const img = new PIXI.ImageResource(source);
  await img.load();
  // If dont use min debounse image can accept 1px as w/h size
  await debounce();
  if (img.width !== texture.width) {
    console.log('Debuglog images sizes', img.width, texture.width);
  }
  return { [id]: texture };
}
